import type { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { MplButton } from '../../atoms/MplButton/MplButton';
import { CheckmarkIcon } from '../../icons/Checkmark';
import { MplModal } from '../../organisms/MplModal/MplModal';
import { CompleteAnim } from '../Animations';

export interface UploadSuccessModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	label: string;
	description: string;
	btnName: string;
	dataTestid?: string;
}

export const SuccessModalWithDate: FC<UploadSuccessModalProps> = ({
	isOpen,
	onClose,
	title,
	label,
	description,
	btnName,
	dataTestid = 'success-modal',
}) => (
	<MplModal
		testId={dataTestid}
		icon={<CompleteAnim />}
		open={isOpen}
		onClose={onClose}
		content={
			<Stack width="100%" gap={3} color="primary.dark">
				<Typography variant="title">{title}</Typography>
				<Typography variant="body1" fontWeight={600}>
					{label}
				</Typography>
				<Stack direction="row" alignItems="center">
					<CheckmarkIcon />
					<Typography variant="body2">
						{dayjs().format('DD.MM.YYYY')}
					</Typography>
				</Stack>
				<Typography variant="body2">{description}</Typography>
			</Stack>
		}
		buttons={
			<MplButton fullWidth onClick={onClose}>
				{btnName}
			</MplButton>
		}
	/>
);

export default SuccessModalWithDate;
